import { createSlice } from "@reduxjs/toolkit";
import { ToastPosition, Theme, TypeOptions } from "react-toastify";

export interface SnackBarInterface {
  position?: ToastPosition | undefined;
  autoClose?: number;
  hideProgressBar?: boolean;
  closeOnClick?: boolean;
  pauseOnHover?: boolean;
  draggable?: boolean;
  progress?: undefined;
  theme?: Theme | undefined;
  type?: TypeOptions | undefined;
}

type sliceState = {
  openDrawer: boolean;
  page: number;
  perPage: number;
  total: number;
  darkMode: "light" | "dark";
  isLoading: boolean;
  isLoadingPromocionesPenal: boolean;
  disabledSubmitButton: boolean;
  messageLoading: string;
  openSnackBar: boolean;
  messageSnackBar: string;
  optionsSnackBar: SnackBarInterface;
  showSkeleton: boolean;
  siteUnderMaintenance: boolean;
  sharedModal: boolean;
  order: "asc" | "desc";
  orderBy: string | number;
  modalTour: boolean;
  ayudaTour: boolean;
};

export const uiSlice = createSlice({
  name: "ui",
  initialState: {
    openDrawer: false,
    page: 0,
    perPage: 5,
    total: 0,
    darkMode: "light",
    isLoading: false,
    isLoadingPromocionesPenal: false,
    messageLoading: "",
    openSnackBar: false,
    messageSnackBar: "",
    showSkeleton: false,
    disabledSubmitButton: false,
    optionsSnackBar: {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      type: "success",
    },
    siteUnderMaintenance: false,
    sharedModal: false,
    order: "asc",
    orderBy: "",
    modalTour:true,
    ayudaTour: false,
  } as sliceState,
  reducers: {
    onOpenDrawer: (state, { payload }) => {
      state.openDrawer = payload;
    },
    onChangePage: (state, { payload }) => {
      state.page = payload;
    },
    onChangePerPage: (state, { payload }) => {
      state.perPage = payload;
    },
    onChangeTotal: (state, { payload }) => {
      state.total = payload;
    },
    onResetPaginate: (state) => {
      state.page = 0;
      state.perPage = 5;
      state.total = 0;
    },
    onDarkMode: (state, { payload }) => {
      state.darkMode = payload;
    },
    setIsLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setIsLoadingPromocionesPenal: (state, { payload }) => {
      state.isLoadingPromocionesPenal = payload;
     },
    setMessageLoading: (state, { payload }) => {
      state.messageLoading = payload;
    },
    onShowSkeleton: (state, { payload }) => {
      state.showSkeleton = payload;
    },
    onDisabledSubmitButton: (state, { payload }) => {
      state.disabledSubmitButton = payload;
    },
    setOpenSnackBar: (state, { payload }) => {
      state.openSnackBar = payload.status;
      state.messageSnackBar = payload.message;
      state.optionsSnackBar = payload.optionsSnackBar || state.optionsSnackBar;
    },
    onChangeSiteMaintenance: (state, { payload }) => {
      state.siteUnderMaintenance = payload;
    },
    onOpenSharedModal: (state, { payload }) => {
      state.sharedModal = payload;
    },
    onAddOrder: (state, { payload }) => {
      state.order = payload;
    },
    onOrderBy: (state, { payload }) => {
      state.orderBy = payload;
    },
    onModalTour: (state, { payload }) => {
      state.modalTour = payload;
    },
    onAyudaTour: (state, { payload }) => {
      state.ayudaTour = payload;
    },
  },
});

export const {
  onOpenDrawer,
  onChangePage,
  onChangePerPage,
  onChangeTotal,
  onResetPaginate,
  onDarkMode,
  setIsLoading,
  setIsLoadingPromocionesPenal,
  setMessageLoading,
  setOpenSnackBar,
  onShowSkeleton,
  onDisabledSubmitButton,
  onChangeSiteMaintenance,
  onOpenSharedModal,
  onAddOrder,
  onOrderBy,
  onModalTour,
  onAyudaTour,
} = uiSlice.actions;
